<template>
  <c-box>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Nilai Pengukuran Lingkar Pinggang (cm)
      </c-form-label>
      <c-input-group size="md">
        <c-input
          type="number"
          min="0"
          error-border-color="red.300"
          placeholder="Masukkan Nilai Pengukuran Lingkar Pinggang (cm)"
          height="62px"
          v-model="value.waistSize"
        />
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Standar Lingkar Pinggang
      </c-form-label>
      <c-input-group size="md">
        <c-select
          v-model="value.waistSizeStandard"
          placeholder="Masukan Standar Lingkar Pinggang"
          height="62px"
        >
          <option value="Laki-Laki">Laki-Laki</option>
          <option value="Perempuan">Perempuan</option>
        </c-select>
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Kesimpulan Lingkar Pinggang
      </c-form-label>
      <c-input-group size="md">
        <c-select
          v-model="value.waistSizeConclusion"
          placeholder="Masukan Kesimpulan Lingkar Pinggang"
          height="62px"
        >
          <option value="Normal">Normal</option>
          <option value="Berlebih">Berlebih</option>
        </c-select>
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Nilai Pengukuran % Lemak Tubuh
      </c-form-label>
      <c-input-group size="md">
        <c-input
          type="number"
          min="0"
          error-border-color="red.300"
          placeholder="Masukkan Nilai Pengukuran % Lemak Tubuh"
          height="62px"
          v-model="value.fat"
        />
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Standar % Lemak Tubuh
      </c-form-label>
      <c-input-group size="md">
        <c-select
          v-model="value.fatStandard"
          placeholder="Masukan Standar % Lemak Tubuh"
          height="62px"
        >
          <option value="Laki-Laki">Laki-Laki</option>
          <option value="Perempuan">Perempuan</option>
        </c-select>
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Kesimpulan % Lemak Tubuh
      </c-form-label>
      <c-input-group size="md">
        <c-select
          v-model="value.fatConclusion"
          placeholder="Masukan Kesimpulan % Lemak Tubuh"
          height="62px"
        >
          <option value="Rendah">Rendah</option>
          <option value="Normal">Normal</option>
          <option value="Tinggi">Tinggi</option>
          <option value="Sangat Tinggi">Sangat Tinggi</option>
        </c-select>
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Nilai Pengukuran Visceral Fat
      </c-form-label>
      <c-input-group size="md">
        <c-input
          type="number"
          min="0"
          error-border-color="red.300"
          placeholder="Masukkan Nilai Pengukuran Visceral Fat"
          height="62px"
          v-model="value.visceralFat"
        />
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Standar Visceral Fat
      </c-form-label>
      <c-input-group size="md">
        <c-input
          type="text"
          min="0"
          error-border-color="red.300"
          placeholder="Masukkan Standar Visceral Fat"
          height="62px"
          v-model="value.visceralFatStandard"
        />
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Kesimpulan Visceral Fat
      </c-form-label>
      <c-input-group size="md">
        <c-select
          v-model="value.visceralFatConclusion"
          placeholder="Masukan Kesimpulan Visceral Fat"
          height="62px"
        >
          <option value="Normal">Normal</option>
          <option value="Berlebih">Berlebih</option>
        </c-select>
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Nilai Pengukuran Massa Otot
      </c-form-label>
      <c-input-group size="md">
        <c-input
          type="text"
          min="0"
          error-border-color="red.300"
          placeholder="Masukkan Nilai Pengukuran % Lemak Tubuh"
          height="62px"
          v-model="value.muscleMass"
        />
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Standar Massa Otot
      </c-form-label>
      <c-input-group size="md">
        <c-select
          v-model="value.muscleMassStandard"
          placeholder="Masukan Standar Massa Otot"
          height="62px"
        >
          <option value="Laki-laki">Laki-laki</option>
          <option value="Perempuan">Perempuan</option>
        </c-select>
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Kesimpulan Massa Otot
      </c-form-label>
      <c-input-group size="md">
        <c-select
          v-model="value.muscleMassConclusion"
          placeholder="Masukan Kesimpulan Massa Otot"
          height="62px"
        >
          <option value="Rendah">Rendah</option>
          <option value="Normal">Normal</option>
          <option value="Tinggi">Tinggi</option>
          <option value="Sangat Tinggi">Sangat Tinggi</option>
        </c-select>
      </c-input-group>
    </c-form-control>

  </c-box>
</template>

<script>
export default {
  name: "BodyCompositionMeasureForm",
  props: ["value"],
}
</script>